"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var react_use_1 = require("react-use");

var FaMinus_1 = require("@react-icons/all-files/fa/FaMinus");

var FaPlus_1 = require("@react-icons/all-files/fa/FaPlus");

var Clickable_1 = require("./Clickable");

var Block_1 = require("./Block");

var utils_1 = require("../utils");

var HeaderWrapper = styled_components_1.default(Clickable_1.Clickable)(function (_a) {
  var color = _a.color;
  return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 400;\n    font-size: 1rem;\n    cursor: pointer;\n    outline: 0;\n    padding: 1rem;\n    width: 100%;\n  "], ["\n    color: ", ";\n    font-weight: 400;\n    font-size: 1rem;\n    cursor: pointer;\n    outline: 0;\n    padding: 1rem;\n    width: 100%;\n  "])), color);
});

var IconStyles = function IconStyles() {
  return "\n  margin-right: 1rem;\n  cursor: pointer;\n";
};

var MinusIcon = styled_components_1.default(FaMinus_1.FaMinus)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), IconStyles);
var PlusIcon = styled_components_1.default(FaPlus_1.FaPlus)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), IconStyles);
var StyledBorder = styled_components_1.default.div(function (_a) {
  var isFocused = _a.isFocused,
      backgroundColor = _a.backgroundColor,
      borderColor = _a.borderColor,
      focusBorderColor = _a.focusBorderColor,
      borderRadius = _a.borderRadius,
      shadow = _a.shadow;
  return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    background-color: ", ";\n    border: 1px solid ", ";\n    margin-bottom: 10px;\n    border-radius: ", "px;\n    box-shadow: ", ";\n\n    ", "\n  "], ["\n    background-color: ", ";\n    border: 1px solid ", ";\n    margin-bottom: 10px;\n    border-radius: ", "px;\n    box-shadow: ", ";\n\n    ", "\n  "])), backgroundColor, borderColor, borderRadius, shadow, isFocused && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        border: 1px solid ", ";\n      "], ["\n        border: 1px solid ", ";\n      "])), focusBorderColor));
});
var ChildrenContainer = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var color = _a.color,
      backgroundColor = _a.backgroundColor,
      borderRadius = _a.borderRadius;
  return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n    padding: 1rem;\n    color: ", ";\n    border-radius: 0 0 ", "px ", "px;\n    background-color: ", ";\n  "], ["\n    width: 100%;\n    height: 100%;\n    padding: 1rem;\n    color: ", ";\n    border-radius: 0 0 ", "px ", "px;\n    background-color: ", ";\n  "])), color, borderRadius, borderRadius, backgroundColor);
});

function Collapse(_a) {
  var size = _a.size,
      title = _a.title,
      variant = _a.variant,
      children = _a.children,
      initiallyExpanded = _a.initiallyExpanded;
  var theme = styled_components_1.useTheme();

  var _b = utils_1.getComponentThemeStyles(theme, 'Collapse', variant, size),
      color = _b.color,
      borderColor = _b.borderColor,
      backgroundColor = _b.backgroundColor,
      focusBorderColor = _b.focusBorderColor,
      borderRadius = _b.borderRadius,
      shadow = _b.shadow;

  var _c = react_use_1.useToggle(false),
      isFocused = _c[0],
      toggleFocus = _c[1];

  var _d = react_use_1.useToggle(initiallyExpanded),
      isExpanded = _d[0],
      toggleExpanded = _d[1];

  var IconComponent = isExpanded ? MinusIcon : PlusIcon;
  return React.createElement(StyledBorder, {
    shadow: shadow,
    borderRadius: borderRadius,
    borderColor: borderColor,
    backgroundColor: backgroundColor,
    focusBorderColor: focusBorderColor,
    isFocused: isFocused
  }, React.createElement(HeaderWrapper, {
    color: color,
    onFocus: toggleFocus,
    onBlur: toggleFocus,
    onClick: toggleExpanded
  }, React.createElement(Block_1.Block, {
    mr: "auto"
  }, React.createElement(IconComponent, {
    "data-testid": "icon-collapse"
  }), title)), isExpanded && React.createElement(ChildrenContainer, {
    borderRadius: borderRadius,
    color: color,
    backgroundColor: backgroundColor
  }, children));
}

exports.Collapse = Collapse;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;